import SubCategoryCard from '../../../components/cards/SubCategoryCard';
import { useFetchSubCategories } from '../../../lib/fetches';
import CategoriesTabs from '../../../components/tabs/CategoriesTabs.tsx';
import { useAuth } from '../../../lib/auth';
import { useParams } from 'react-router';
import AuthLayout from '../../layouts/AuthLayout';
import { SkeletonSubCategoryCard } from '../../../components/Skeleton';
import clsx from 'clsx';
import { EmptyState } from '../../../components/emptyStates/EmptyState.tsx';
import { LectureCategory } from '../../../lib/types.ts';

interface SubCategoryListProps {
    items: LectureCategory[] | undefined;
    isLoading: boolean;
    showBadges: boolean;
}

function SubCategoryList({
    items,
    isLoading,
    showBadges,
}: SubCategoryListProps) {
    return (
        <>
            {isLoading ? (
                <SkeletonSubCategoryCard count={8} className="mb-8" />
            ) : (
                <>
                    {items?.length ? (
                        <div className="grid grid-cols-1 gap-8 lg:grid-cols-2">
                            {items?.map((lectureCategory) => (
                                <SubCategoryCard
                                    key={lectureCategory.slug}
                                    lectureCategory={lectureCategory}
                                    showBadge={showBadges}
                                />
                            ))}
                        </div>
                    ) : (
                        <></>
                    )}
                </>
            )}
        </>
    );
}

export default function CategoryPage() {
    useAuth({
        middleware: 'auth',
        redirectTo: '/',
        tmp: 'CategoryPage',
    });

    const { category = 'vse' } = useParams();

    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const { data: subCategories, isLoading } = useFetchSubCategories(category!);

    return (
        <AuthLayout>
            <main
                className={clsx(
                    'mx-auto box-content max-w-6xl py-9',
                    'px-4 sm:px-8 md:px-10'
                )}
            >
                <h1>Cvičení</h1>
                <p className="text-lg text-ink-800">
                    Vyberte si, co dnes procvičíte.
                </p>

                <div className="mb-12 mt-8">
                    <CategoriesTabs />
                </div>

                {!subCategories?.length && !isLoading ? (
                    <EmptyState>
                        Tato kategorie zatím neobsahuje žádná cvičení.
                    </EmptyState>
                ) : (
                    <></>
                )}

                {/* grid auto-cols-min grid-flow-col auto-rows-min gap-12 */}
                {subCategories?.length ? (
                    <SubCategoryList
                        isLoading={isLoading}
                        items={subCategories}
                        showBadges={category === 'vse'}
                    />
                ) : isLoading ? (
                    <div className="grid grid-cols-2 gap-8">
                        <SkeletonSubCategoryCard count={8} />
                    </div>
                ) : (
                    <></>
                )}
            </main>
        </AuthLayout>
    );
}
